// @ts-check
import { useEffect } from 'react';

const useEventListener = (event, callback, options = false, target = global.document) => {
  if (typeof target === 'undefined' && typeof window === 'undefined') { // SSR
    return;
  }

  if (typeof target === 'undefined' || target === null) {
    throw new Error('useEventListener: target is not specified');
  }

  if (typeof callback !== 'function') {
    throw new Error('useEventListener: callback is not a function');
  }

  useEffect(() => {
    target.addEventListener(event, callback, options);

    return () => target.removeEventListener(event, callback);
  }, []);
};

/* @component */
export default useEventListener;
